import { render } from "./EmailList.vue?vue&type=template&id=4724256e&scoped=true"
import script from "./EmailList.vue?vue&type=script&lang=js"
export * from "./EmailList.vue?vue&type=script&lang=js"

import "./EmailList.vue?vue&type=style&index=0&id=4724256e&lang=less"
import "./EmailList.vue?vue&type=style&index=1&id=4724256e&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4724256e"]])

export default __exports__